/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Dashboard.css';
import Link from './../../components/Link/';
import Ranktable from './../../components/Ranktable';
import Time from './../../components/Time';
import Article from './../../components/Article';
import cx from 'classnames';
import Floatlogin from './../../components/Floatlogin'
import history from '../../history';
import Floattip from './../../components/Floattip';
import FloatBottom from './../../components/FloatBottom';
import moment from 'moment'
// @ts-ignore
import loadGif from './loading.gif'
// @ts-ignore
import errorPic from './error.png'
import AddBrand from './../../components/AddBrand'


// 选择任意时间
import SeleTime from './../../components/SeleTime'

// 更多品牌
import FloatMoreBrand from './../../components/FloatMoreBrand'


import BrandSelect from './../../components/BrandSelect'

//修改db值
import ChangeDB from './../../components/ChangeDB'




const list = [
    [
    '心智占有率',
    'DB总值构成图',
    '历史曲线图',
    '品牌三维图',
    '三维曲线图',
    'KOL参与图',
    '口碑舆情图',
    '受众好感图'
  ],
  [
    '心智占有率',
    'DB值构成图',
    '历史曲线图',
    '品牌三维图',
    '三维曲线图',
    'KOL参与图',
    '口碑舆情图',
    '受众好感图'
  ] 
]


const theadList=[
  [
    '排名',
    'DB总值',
    '日涨跌幅',
    '传播度',
    '参与度',
    '好感度',
    '心智占有率',
  ],[
    '排名',
    'DB值',
    '日涨跌幅',
    '传播度',
    '参与度',
    '好感度',
    '心智占有率',
  ],[
    '品牌名称',
    '排名',
    'DB值',
    '日涨跌幅',
    '传播度',
    '参与度',
    '好感度',
    '心智占有率',
  ]
]


const LoadingEle = () => <div className={s.loadingBox}><img src={loadGif}/></div>
const ErrorEle = () => <div className={s.errorBox}><div className={s.box}><img src={errorPic}/></div></div>


class Dashboard extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    // items:PropTypes.Array.isRequired
  };

  constructor(props) {
    super(props)
    this.state = {
      name:'',
      id:7,
      isFixed:false,
      listIndex: 0,
      value: '',
      isExpiered:false,

      items:[],
      data:null,
      error:false,
      isShowFloat:null,
      isShowTip:null,
      time:null,
      loading:false,
      active: 5,
      timeItems:[],
      isChangeUrl:false,
      moreBrand:false,
      brandComList:[],
      mindList:[],

      //areaMind
      battleAllBrand:true,
      


      // 修改db 值
      isOpenChangeBox:false,
      
    }
    this.close=this.close.bind(this)
    // this.getArtTime=this.getArtTime.bind(this);
    this.getArtTime=this.getArtTime.bind(this)
    this.seaBrand=this.seaBrand.bind(this)
    this.changeTime=this.changeTime.bind(this)
    this.doBrandIndustryBattle=this.doBrandIndustryBattle.bind(this)
    this.topTime=this.topTime.bind(this)
  }
  
  //选择任意时间
  topTime=(time)=>{
    let arrTime=[]
    for(let i=7;i>0;i--){
      arrTime.push(moment(time).subtract(i-1,'days').format('YYYY-MM-DD'))
    }
    this.setState({
      timeItems:arrTime
    })
  }



  
  getQueryString(name) {   
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");   
    var r = window.location.search.substr(1).match(reg);   
    if (r != null) return decodeURI(r[2]); return null;   
  }  

  close=()=>{
    // console.log('jaja')
    this.setState({isShowFloat:false,isShowTip:false,isExpiered:false})
  }

  getArtTime=(ss)=>{
    this.setState({
        time:ss
    })
  }
  brandEncodeList=(items)=>{
    let list=[]
 
    
    for(let i=0;i<items.length;i++){
      let deUrl=decodeURIComponent(items[i].name)
      let enUrl=encodeURIComponent(deUrl)  
      list.push(enUrl)
    }
    let aa=list.join(',')


    return aa
  }
  changeTime=(index)=>{
    const aa=this.state.timeItems[index]
    const item = this.state.items

    this.setState({active:index})
    // let aa=moment().format('a')=='pm'?moment().subtract(1,'days').format('YYYY-MM-DD'):moment().subtract(2,'days').format('YYYY-MM-DD')
    let brandName = item || this.props.query
    let url = `/digitalAssets/center/brandDetail?brandNames=${this.brandEncodeList(brandName)}&statisDate=${aa}`;
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
     };
     if(this.props.childrenData=='品牌详情'){

     }else if(this.props.childrenData==''){

     }else{

       url=`/digitalAssets/center/brandDetail?brandNames=${this.brandEncodeList(brandName)}&areaIndustry=${this.enBrand(this.props.childrenData)}&statisDate=${aa}`
     }

     fetch(url,myInit)
    //  fetch(url)
     
      .then(response => response.json())
      .then(data => {
       
        if(data.err_code){

         this.errCodeAction(data)

        }else{
          this.setState({
            items:data,
            // id:data.id,
            // name:data.name,
            // brandComList:data.brandList,
            // mindList:data.mindList,
          })
          let brandInfo={
            mindList:data.mindList||[],
            brandList:[data.name]
          }
          // this.props.doNewItem(brandInfo)
        }
      })
      .catch(e => {
        console.log("Oops, error", e)
        this.setState({
        })
    })
  }


  componentWillMount() {
    let arrItem=[]
    // if (moment().format('a') == 'pm') {
    //   for (let i = 7; i > 0; i--) {
    //     arrItem.push(moment().subtract(i, 'd').format('YYYY-MM-DD'))
    //   }
    // } else {
    //   for (let i = 8; i > 1; i--) {
    //     arrItem.push(moment().subtract(i, 'd').format('YYYY-MM-DD'))
    //   }

    // }
    for (let i = 6; i > -1; i--) {
      arrItem.push(moment().subtract(i, 'd').format('YYYY-MM-DD'))
    }
    this.setState({ timeItems: arrItem })
  }

  enBrand=(brand)=>{
    return encodeURIComponent(decodeURIComponent(brand))
  }

  errCodeAction=(data)=>{
    console.log(data,data.err_code=='need_login',data.err_code)

    if(data.err_code=='need_login'){
      localStorage.setItem('isLogin','false')
      history.replace('/dashboard?brandName=腾讯')
      window.scroll(window.screenLeft,window.screenTop+1)
      
      // alert('需要登录')
      this.setState({isShowFloat:true})
    }else if(data.err_code=='trial account expired'){
      history.replace('/dashboard?brandName=腾讯')
      this.setState({isExpiered:true})
      
      // alert('账号已经过期')
    }else if(data.err_code=='date out of range'){
      history.replace('/dashboard?brandName=腾讯')
      
    }else if(data.err_code=='deny'){
      history.replace('/dashboard?brandName=腾讯')
      this.setState({moreBrand:true})
      // alert('最多只能查看5个品牌')
      
    }else if(data.err_code=='account expired'){
      history.replace('/dashboard?brandName=腾讯')
      this.setState({moreBrand:true})
      
      // alert('正式账号过期，最多五个品牌')

    }else if(data.err_code=='404'){
      history.replace('/dashboard?brandName=腾讯')
      
      this.setState({isShowTip:true})
    }else if(data[0]&&data[0].err_code=='404'){
      history.replace('/dashboard?brandName=腾讯')
      
      this.setState({isShowTip:true})
    }else {
      this.setState({error:true})
    }
  }
  

  componentDidMount() {
    // console.log('componentDidMount componentDidMount componentDidMount')
    this.setState({loading:true})
    // console.log(this.props.childrenData,this.props.childrenData!='品牌详情')
    let seaBrandName,industryForm,isGeoForm

    let intBrand=localStorage.getItem('isLogin')=='true'?localStorage.getItem('company'):'腾讯'
    // localStorage.getItem('isLogin')!='true'?this.setState({isShowFloat:true}):null

    seaBrandName =this.getQueryString('brandName')=='demo'?'腾讯,阿里巴巴':this.getQueryString('brandName')||intBrand
    industryForm = this.getQueryString('industry')==null?null:this.getQueryString('industry')
    isGeoForm = this.getQueryString('geo')==null?null:this.getQueryString('geo')

    
    // let aa=moment().format('a')=='pm'?moment().subtract(1,'days').format('YYYY-MM-DD'):moment().subtract(2,'days').format('YYYY-MM-DD')
    let aa=this.state.timeItems[this.state.active]
    // let aa='2018-05-14'
  
    let url = `/digitalAssets/center/brandDetail?brandNames=${this.enBrand(seaBrandName)}&statisDate=${aa}`;
    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };

    if(industryForm){
      url=`/digitalAssets/center/brandDetail?brandNames=${this.enBrand(this.props.query)}&areaIndustry=${this.enBrand(this.props.childrenData)}&statisDate=${aa}`
    }

   fetch(url,myInit)
    // fetch(url)
    .then(response => {
      return response.json()
    })
    .then(data => {
      if(data.err_code||data[0]&&data[0].err_code=='404'){
        this.errCodeAction(data)
      }else{
        let battleAll=true
          if(industryForm){
          battleAll=false
        }
        this.setState({
          items:data,
          id:data[0].id,
          name:data[0].name,
          brandComList:data[0].brandList,
          mindList:data[0].mindList,
          battleAllBrand:battleAll

        })
        let brandInfo={
          mindList:data[0].mindList||[],
          brandList:[data[0].name]
        }
        if(data[1]){
          brandInfo.brandList.push(data[1].name)
          this.props.doChangeLevel(1)
        }

        if(!this.getQueryString('industry')){
          this.props.doChangeLevel(1)
        }

        // console.log(brandInfo,'brandInfo````````````````')
        this.props.doNewItem(brandInfo)
      }
    })
    .catch(e => {
      this.setState({
        name: seaBrandName,
        items: []
        // error:true,
      })
    })

      
  }


  componentWillReceiveProps(nextProps) {
    // console.log('componentWillReceiveProps')

    if(nextProps.query!=this.props.query){
      this.seaBrand()
      // console.log(nextProps.query,'query')
      // console.log('this is bug ,====> 已经进入品牌页点击再次点击品牌详情不重置状态')
    }
    // if(this.getQueryString('areaIndustry')){
    //   console.log(this.getQueryString('mind'))
    //   this.seaBrand(this.props.query,this.getQueryString('areaIndustry'))
    // }

    if(nextProps.getNewUrl!=this.props.getNewUrl){
      this.getBrandAreaInfo(nextProps.getNewUrl)
      // console.log(nextProps.getNewUrl,'getNewUrl')
      
    }

    // if(nextProps.childrenData=='品牌详情'){
    //   this.setState({battleAllBrand:true})
    //   this.getBrandAreaInfo(nextProps.getNewUrl)
      
    // }else if(nextProps.childrenData!='品牌详情'){
    //   this.setState({battleAllBrand:false})
    //   this.getBrandAreaInfo(nextProps.getNewUrl)
      
    // }

  }

 


  getBrandAreaInfo=([brand,area])=>{
    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };

    // let aa=moment().format('a')=='pm'?moment().subtract(1,'days').format('YYYY-MM-DD'):moment().subtract(2,'days').format('YYYY-MM-DD')
    let aa=this.state.timeItems[this.state.active]
    // let aa='2018-05-14'
    
    area?this.setState({battleAllBrand:false,item:[]}):this.setState({battleAllBrand:true,item:[]})

    let url=area?`/digitalAssets/center/brandDetail?brandNames=${this.enBrand(brand)}&areaIndustry=${this.enBrand(area)}&statisDate=${aa}`
           :`/digitalAssets/center/brandDetail?brandNames=${brand}&statisDate=${aa}`
    
    fetch(url,myInit) 
      .then(response => response.json())
      .then(data => {
        // console.log(data,'品牌数据···················')
        if(data.err_code){
          this.errCodeAction(data)
        }else{

          if(this.props.childrenData==data[0].industry||this.props.childrenData=='品牌详情'){

            this.setState({
              items:data,
              // id:data.id,
              brandComList:data[0].brandList,
              mindList:data[0].mindList
            })
            let brandInfo={
              mindList:data[0].mindList||[],
              brandList:[data[0].name]
            }
            this.props.doNewItem(brandInfo)
          }
          
        }
      })
      .catch(e => console.log("Oops, error", e))
    
  }


  



  

  seaBrand=(brand,industry)=>{
    let intBrand=localStorage.getItem('isLogin')=='true'?localStorage.getItem('company'):'腾讯'
    // localStorage.getItem('isLogin')!='true'?this.setState({isShowFloat:true}):null

    let brandName =this.getQueryString('brandName')==null?intBrand:this.getQueryString('brandName')
    //  brandName= brand?brand:this.getQueryString('brandName')
    // let brandName = this.getQueryString('brandName')==null?(localStorage.getItem('isLogin')=='true'?localStorage.getItem('company'):'腾讯'):brand


    // console.log(deUrl,enUrl,brand,brandName)
    if(!this.state.error){
      // let aa=moment().format('a')=='pm'?moment().subtract(1,'days').format('YYYY-MM-DD'):moment().subtract(2,'days').format('YYYY-MM-DD')
      let aa=this.state.timeItems[this.state.active]
      // let aa='2018-05-14'
      
      let url = `/digitalAssets/center/brandDetail?brandNames=${this.enBrand(brandName)}&statisDate=${aa}`;
      if(industry){
       url=`/digitalAssets/center/brandDetail?brandNames=${this.enBrand(this.props.query)}&areaIndustry=${this.enBrand(industry)}&statisDate=${aa}`
       
      }
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
      
  
      fetch(url,myInit)
        .then(response => response.json())
        .then(data => {
          if(data.err_code){

            this.errCodeAction(data)
          }else{
              this.setState({
                items:data,
                id:data.id,
                brandComList:data[0].brandList,
                mindList:data[0].mindList,
                battleAllBrand:true,
            })
            let brandInfo={
              mindList:data[0].mindList||[],
              brandList:[data[0].name]
            }
            this.props.doChangeRank('品牌详情')
            this.props.doChangeLevel(1)
            this.props.doNewItem(brandInfo)
          }
        })
        .catch(e => console.log("Oops, error", e))
    }
    
  }

  doBrandIndustryBattle=(brand,battle)=>{
    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };


    // let aa=moment().format('a')=='pm'?moment().subtract(1,'days').format('YYYY-MM-DD'):moment().subtract(2,'days').format('YYYY-MM-DD')
    let aa=this.state.timeItems[this.state.active]
    // let aa='2018-05-14'
    
    let url
    if(this.props.childrenData&&!battle){
      url=`/digitalAssets/center/brandDetail?brandNames=${this.enBrand(brand)}&areaIndustry=${this.enBrand(this.props.childrenData)}&statisDate=${aa}`
    }else{
       url = `/digitalAssets/center/brandDetail?brandNames=${this.enBrand(brand)}&statisDate=${aa}`;
      
    }

     fetch(url,myInit)
    // fetch(url)
    
      .then(response => response.json())
      .then(data => {

        if(data.err_code){
         this.errCodeAction(data)
        }else{
          this.setState({
            items:this.state.items.concat(data),
            // id:data[0].id,
            name:data.name,
            // brandComList:data[0].brandList,
            // mindList:data[0].mindList
          })

          const brandNameItem=[]
          this.state.items.map(i=>{
            console.log(i)
            brandNameItem.push(i.name)
          })

          let brandInfo={
            mindList:data[0].mindList?data[0].mindList:this.state.mindList||[],
            brandList:brandNameItem
          }
          console.log(brandNameItem,data[0].mindList)
          
          this.props.doNewItem(brandInfo)
        }
      })
      .catch(e => {
        console.log("Oops, error", e)
        // history.replace('/dashboard?brandName=腾讯')
        this.setState({
          // error:true,
        })
    })
  }


  closeCard=(item)=>{
    // console.log(index)
    let aa=this.state.items

    let cc=aa.filter(items=>{
       if(items!=item){
        return items
      }
    })
    

    this.setState({items:cc})


    let name=[].concat(cc.map(i=>i.name))
    // console.log(cc,this.state.items,this.state.mindList)
    let brandInfo={
      mindList:this.state.mindList||[],
      brandList:name
    }
    this.props.doNewItem(brandInfo)

    
  }

   


  
  
  
 




  
  render() {
    const { isOpenChangeBox,listIndex,data,items,id,name,active,moreBrand,isShowFloat,battleAllBrand,brandComList} = this.state
    const { childrenData,treeLevel }=this.props

    let aa=this.state.timeItems[this.state.active]
    let articleTime=(`${moment(aa).subtract(6,'days').format('YYYY-MM-DD')},${moment(aa).format('YYYY-MM-DD')}`)
    
    let chartsTime=(`${moment(aa).format('YYYY-MM-DD')}`)
    const chartsBtn=childrenData=='品牌详情'?list[0]:list[1]

    const cardMap=childrenData=='品牌详情'||childrenData==''?theadList[0]:theadList[1]
    
    
    if(this.state.items!=null&&!this.state.error){
      return (
        <div className={s.root}>
          {this.state.isShowTip&&<Floattip show={this.state.isShowTip} close={()=>this.setState({isShowTip:false})}/>}
        <div className={s.content}>
          {/* <!--头部--> */}
          <div className={s.conHead}>
            {items&&items.map((brand,index)=>
              <div className={s.cardRoot} key={index}>
                <div className={s.card}>
                  {this.props.treeLevel>1&&<span className={s.segmentation}><div>细分领域</div></span>}
                  <div className={s.cardImg}>
                    <img src={`/digitalAssets/resources/img/LOGO/${brand.id}.png`} />
                  </div>
                  <div className={s.cardTxt}>
                    <div className={s.cardName}>
                      {brand.name}
                    </div>
                    
                    <div className={s.cardAdd}>
                      <span className={s.attr}>{brand.region}</span>
                      {treeLevel==1&&<span className={s.industry}>行    业：{treeLevel==1?brand.industry:brand.fatherIndustry}</span>}
                      {treeLevel>1&&<span className={s.areaIn}>领域：{this.props.childrenData}</span>}
                    </div>
                  </div>
                 <div className={ s.cardClose} 
                    onClick={(index) => {
                      this.closeCard(brand)
                      }
                  }>×</div>
                </div>
   
                {index==0&&<div className={s.dbBtn} onClick={()=>this.setState({isOpenChangeBox:!isOpenChangeBox})}>修改DB值</div>}
                {index==0&&<ChangeDB  time={aa} name={brand.name} show={isOpenChangeBox} close={()=>this.setState({isOpenChangeBox:!isOpenChangeBox})} id={brand.id}  />}
              </div>
            )}
            
            {battleAllBrand?
              <div className={s.flex}>
                <AddBrand getBattle={this.doBrandIndustryBattle} items={items}  battle={false}/>
              </div>
              :<div className={s.flex}>
                {!battleAllBrand&&<BrandSelect items={items} doBattle={this.doBrandIndustryBattle} autoComplete={this.state.brandComList}/>}
              </div>
            }
          </div>

          
          <div className={s.industryTable} >
            <table cellSpacing="0" cellPadding="0">
              <thead>
                {items.length>1
                  ?<tr>
                    {theadList[2].map((i,index)=>
                      <th key={index}>{i}</th>
                    )}
                  </tr>
                  :<tr>
                    {cardMap.map((i,index)=>
                      <th key={index}>{i}</th>
                    )}
                  </tr>
                }
              </thead>
              <tbody>
                {items.map((i,index)=>
                  <tr key={index}>
                    {items.length>1&&<td>{i.name}</td>}
                    <td>{i.areaIndustryRank||i.ranking}</td>
                    <td>{parseFloat(i.db).toLocaleString()}</td>
                    <td>{i.daily}<span className={s[i.dailyStyle]}></span></td>
                    <td>{i.spread}</td>
                    <td>{i.participate}</td>
                    <td>{i.favorability}</td>
                    <td>{i.geoMind||i.areaMind}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
              
            <SeleTime topTime={this.topTime}/>
            <div className={s.time}>
              <ul className={s.timeBall}>
                  {this.state.timeItems.map((item, index) => (
                    <li key={index}
                      className={index == this.state.active ? s.timeNow : ''}
                      onClick={() => this.changeTime(index)}
                    ><a href="javascript:;" ><i></i><span>{item}</span></a></li>
                  ))}
                <div className={s.timeBarBox} style={{transform:`translateX(calc(100% * ${active}))`}}>
                  <div className={s.timeBar} ><i className={s.smallBar}></i></div>
                </div>
              </ul>
             
            </div>
            <div className={s.chartsBox}>

              <ul className={s.picItem}>
                {chartsBtn.map((item, index) =>
                  <li key={index} className={listIndex == index ? cx(s.picBtn, s.ac) : s.picBtn} onClick={() => { this.setState({ listIndex: index }) }}>{item}</li>
                )}

              </ul>
              {/* 展示图表 */}
              <Time 
                id={id} 
                geo={items[0]?items[0].region:null} 
                name={name} 
                time={chartsTime} 
                items={this.state.items} 
                value={this.state.value}
                isShow={list[0][listIndex]} 
                industry={!battleAllBrand?this.props.childrenData:null}  
                getArtTime={this.getArtTime} 
              />
              
            </div>
            {items.length==1&&<Article isLevelIndustry={true} industry={!battleAllBrand?this.props.childrenData:null} time={articleTime} items={this.state.items}/>}
            {
              isShowFloat&&<Floatlogin isFixed={this.state.isFixed} show={this.state.isShowFloat} close={()=>this.setState({isShowFloat:false})}/>
            }
            {this.state.isExpiered&&<FloatBottom show={this.state.isExpiered} close={()=>this.setState({isExpiered:false})}/>}
            <FloatMoreBrand  show={moreBrand}  close={()=>this.setState({moreBrand:false})}  />
            
          </div>
        </div>

      );
    } else if(this.state.error){
      return <ErrorEle />
    } else{
      return <LoadingEle />
    }
  }

}

export default withStyles(s)(Dashboard);



// WEBPACK FOOTER //
// src/routes/dashboard/Dashboard.js